import React from "react";
import "./style.scss";
import clsx from "clsx";

type Props = {};

export const Divider: React.FC<Props> = () => {
  return <div className={clsx("dds-divider")}></div>;
};
